export const ACTIVE_BOOKING_TEMPLATE = 'active';
export const INACTIVE_BOOKING_TEMPLATE = 'inactive';
